import { render } from "./configure_verification_form.html?vue&type=template&id=03fb5708&external"
import script from "./configure_verification_form.js?vue&type=script&lang=js&external"
export * from "./configure_verification_form.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__